var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.discountAdvantagesDto
        ? _c(
            "div",
            [
              _c("div", { staticClass: "row bg-greige mx-0 mb-2 mb-md-3" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex advantage-column p-1 align-items-center",
                    },
                    [
                      _c("span", {
                        staticClass:
                          "icon icon-phone-fund-euro text-primary font-size-30 px-2",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "h4 mb-0 mw-100 mobile-text-center" },
                        [
                          _c("span", {
                            directives: [
                              {
                                name: "msh-html",
                                rawName: "v-msh-html",
                                value:
                                  _vm.discountAdvantagesDto
                                    .offerDescriptionText,
                                expression:
                                  "discountAdvantagesDto.offerDescriptionText",
                              },
                            ],
                            staticClass: "offer-text",
                          }),
                          _vm._v(" "),
                          _c("span", {
                            directives: [
                              {
                                name: "msh-html",
                                rawName: "v-msh-html",
                                value:
                                  _vm.discountAdvantagesDto
                                    .yearlyDiscountsInfoText,
                                expression:
                                  "discountAdvantagesDto.yearlyDiscountsInfoText",
                              },
                            ],
                            staticClass: "break-text",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-secondary ms-auto flex-shrink-0 d-flex justify-content-center align-items-center ms-2 me-2 w-200 mobile-max-width",
                          attrs: {
                            "data-bs-toggle": "modal",
                            "data-bs-target":
                              "#" +
                              _vm.discountAdvantagesDto.discountAdvantagesPopin
                                .id,
                            "data-oevent-category": "vers_popin",
                            "data-oevent-action": "en_savoir_plus",
                            "data-oevent-label":
                              "bannière_remise_client_internet",
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.discountAdvantagesDto.buttonLabel) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("discount-advantages-popin", {
                attrs: {
                  "dto-from-object":
                    _vm.discountAdvantagesDto.discountAdvantagesPopin,
                },
              }),
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass:
                "d-flex align-items-center justify-content-center px-1 py-2 py-lg-1 bg-greige",
            },
            [
              _vm.openCustomerDto
                ? _c("div", [
                    _c("strong", {
                      directives: [
                        {
                          name: "msh-html",
                          rawName: "v-msh-html",
                          value: _vm.openCustomerDto.text,
                          expression: "openCustomerDto.text",
                        },
                      ],
                      attrs: { "data-cs-encrypt": "" },
                    }),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "msh-html",
                          rawName: "v-msh-html",
                          value: _vm.openCustomerDto.subTitle,
                          expression: "openCustomerDto.subTitle",
                        },
                      ],
                    }),
                  ])
                : [
                    _c("div", { staticClass: "me-1" }, [
                      _c("strong", {
                        directives: [
                          {
                            name: "msh-html",
                            rawName: "v-msh-html",
                            value: _vm.switchOpen.label,
                            expression: "switchOpen.label",
                          },
                        ],
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "msh-html",
                            rawName: "v-msh-html",
                            value: _vm.switchOpen.subTitle,
                            expression: "switchOpen.subTitle",
                          },
                        ],
                      }),
                    ]),
                    _vm._v(" "),
                    _c("ob1-switches", {
                      attrs: {
                        "data-test-id":
                          "checkbox-" + _vm.switchOpen.switchDto.id,
                        "switches-d-t-o": _vm.switchOpen.switchDto,
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleSwitch(
                            $event,
                            _vm.switchOpen.switchDto.checked
                          )
                        },
                      },
                    }),
                  ],
            ],
            2
          ),
      _vm._v(" "),
      _c("ob1-snack-bar", {
        ref: "snackbar",
        attrs: { id: "snackbar", label: _vm.snackbarMessage },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }